export default {
  'Start at': '音乐开始于',
  'Set to current time': '设置为当前时间',
  'Audio volume': '音频音量',
  'Video volume': '视频音量',
  'Trim audio': '剪辑音频',
  'Audio will end with the video': '音频会随着视频的结束而结束。',
  'Trim': '截取',
}